import React from "react";
import { partners } from "../mock";

function PartnerLogo({ name }) {
  switch (name) {
    case "FedEx":
      return (
        <span className="text-[28px] font-extrabold tracking-tight">
          <span className="text-[#4D148C]">Fed</span><span className="text-[#FF6600]">Ex</span>
        </span>
      );
    case "amazon":
      return <span className="text-[28px] font-bold text-[#232F3E] lowercase">amazon</span>;
    case "NETFLIX":
      return <span className="text-[26px] font-extrabold tracking-wider text-[#E50914]">NETFLIX</span>;
    case "adidas":
      return <span className="text-[28px] font-extrabold lowercase text-[#1a1a1a]">adidas</span>;
    case "AJAS":
      return (
        <span className="flex flex-col items-center leading-none">
          <span className="text-[26px] font-extrabold text-[#0B7A3B]">AJAS</span>
          <span className="text-[8px] tracking-[0.2em] text-[#6b7280]">AVIATION SERVICES</span>
        </span>
      );
    default:
      return <span>{name}</span>;
  }
}

export default function Partners() {
  return (
    <section className="py-16 lg:py-20 bg-[#fafafa]">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-6">
        <div className="text-center mb-14">
          <h2 className="text-[34px] lg:text-[40px] font-light text-[#1a1a1a]">Our Partners</h2>
          <div className="mx-auto mt-2 w-16 h-1 bg-[#ED2E24] rounded-full" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8 lg:gap-x-16">
          {partners.map((p, i) => (
            <div key={p} className="flex items-center opacity-90 hover:opacity-100 transition-opacity grayscale hover:grayscale-0">
              <PartnerLogo name={p} />
              {i < partners.length - 1 && (
                <span className="hidden lg:block h-8 w-px bg-gray-200 ml-10 lg:ml-16" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
